import { render, staticRenderFns } from "./ot-text-field-wrapper.vue?vue&type=template&id=4f067bc8&scoped=true&"
import script from "./ot-text-field-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-text-field-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-text-field-wrapper.vue?vue&type=style&index=0&id=4f067bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f067bc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VDivider,VForm})
